$(document).ready(() => {
    setTimeout(() => {
        initSliderService();
        initSliderChiffres();
        initSliderValeurs();
    }, 1000);

    $(window).resize(() => {
        initSliderService();
        initSliderChiffres();
        initSliderValeurs();
    });
})

function initSliderService() {
    if (Foundation.MediaQuery.atLeast('large')) {
        if ($(".services-slider").hasClass("owl-carousel")) {
            $(".services-slider").removeClass("owl-carousel").trigger("destroy.owl.carousel");
        }
    }
    else {
        let canModifTranslateSliderService = true;
        $(".services-slider").addClass("owl-carousel").owlCarousel({
            loop: false,
            nav: false,
            margin: 15,
            responsiveRefreshRate: 500,
            responsive: {
                0: {
                    items: 2
                },
                400: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            },
            onTranslated: (event) => {
                const { count: items, index: item } = event.item;
                const { size } = event.page;
                if (item == items - size) {
                    if (!canModifTranslateSliderService) {
                        canModifTranslateSliderService = true;
                        return;
                    }
                    canModifTranslateSliderService = false;
                    // calcul du margin à rajouter pour "coller" le bord droit
                    const marginDiff = parseFloat($(".services-slider").css("margin-right"));
                    // récupère le translate x du slider
                    let tx = parseFloat($(".services-slider .owl-stage").css("transform").split(', ')[4]);
                    tx += +marginDiff;
                    $(".services-slider .owl-stage").css({
                        'transform': `translate3d(${tx}px,0px,0px)`
                    });
                }
            }
        });
    }
}

function initSliderChiffres() {
    if (Foundation.MediaQuery.atLeast('large')) {
        if ($(".chiffres-slider").hasClass("owl-carousel")) {
            $(".chiffres-slider").removeClass("owl-carousel").trigger("destroy.owl.carousel");
        }
    }
    else {
        let canModifTranslateSliderService = true;
        $(".chiffres-slider").addClass("owl-carousel").owlCarousel({
            loop: false,
            nav: false,
            margin: 10,
            items: 1,
            responsiveRefreshRate: 500,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1024: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            },
            onTranslated: (event) => {
                const { count: items, index: item } = event.item;
                const { size } = event.page;
                if (item == items - size) {
                    if (!canModifTranslateSliderService) {
                        canModifTranslateSliderService = true;
                        return;
                    }
                    canModifTranslateSliderService = false;
                    // calcul du margin à rajouter pour "coller" le bord droit
                    const marginDiff = parseFloat($(".chiffres-slider").css("margin-right"));
                    // récupère le translate x du slider
                    let tx = parseFloat($(".chiffres-slider .owl-stage").css("transform").split(', ')[4]);
                    tx += +marginDiff;
                    $(".chiffres-slider .owl-stage").css({
                        'transform': `translate3d(${tx}px,0px,0px)`
                    });
                }
            }
        });
    }
}

function initSliderValeurs() {
    if (Foundation.MediaQuery.atLeast('large')) {
        if ($(".valeurs-slider").hasClass("owl-carousel")) {
            $(".valeurs-slider").removeClass("owl-carousel").trigger("destroy.owl.carousel");
        }
    }
    else {
        let canModifTranslateSliderService = true;
        $(".valeurs-slider").addClass("owl-carousel").owlCarousel({
            loop: false,
            nav: false,
            margin: 30,
            responsiveRefreshRate: 500,
            responsive: {
                0: {
                    items: 1
                },
                600: {
                    items: 2
                },
                1024: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            },
            onTranslated: (event) => {
                const { count: items, index: item } = event.item;
                const { size } = event.page;
                if (item == items - size) {
                    if (!canModifTranslateSliderService) {
                        canModifTranslateSliderService = true;
                        return;
                    }
                    canModifTranslateSliderService = false;
                    // calcul du margin à rajouter pour "coller" le bord droit
                    const marginDiff = parseFloat($(".valeurs-slider").css("margin-right"));
                    // récupère le translate x du slider
                    let tx = parseFloat($(".valeurs-slider .owl-stage").css("transform").split(', ')[4]);
                    tx += +marginDiff;
                    $(".valeurs-slider .owl-stage").css({
                        'transform': `translate3d(${tx}px,0px,0px)`
                    });
                }
            }
        });
    }
}